import '../style.scss';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { IconName, findIcon } from 'utils/handleIcon';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { PagePath } from 'constants/pagePath';
import { useNavigate } from 'react-router-dom';

export const ImpossibleTransactionPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="compatibilityCheck">
        <div className="compatibilityCheck_descriptionWrapper">
          <Description
            label="恐れ入りますが、オンライン取引サービスをご利用いただくことができません。"
            labelColor={labelColor.gray}
            labelSize={labelSize.medium}
          />
        </div>
        <Button
          label="HOMEに戻る"
          buttonFill={ButtonFill.link}
          buttonSize={ButtonSize.small}
          onClick={() => navigate(PagePath.Home)}
        />
      </div>
    </>
  );
};
